import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-1"><path fillRule="evenodd" clipRule="evenodd" d="M2 5.75C2 4.7835 2.7835 4 3.75 4H20.25C21.2165 4 22 4.7835 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75ZM3.75 5.5C3.61193 5.5 3.5 5.61193 3.5 5.75V7H20.5V5.75C20.5 5.61193 20.3881 5.5 20.25 5.5H3.75ZM20.5 8.5H3.5V10H8.75C9.16421 10 9.5 10.3358 9.5 10.75V12.25C9.5 12.3881 9.61193 12.5 9.75 12.5H14.25C14.3881 12.5 14.5 12.3881 14.5 12.25V10.75C14.5 10.3358 14.8358 10 15.25 10H20.5V8.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconWallet1;
